import { useNavigate } from "react-router-dom";
import TestFormInterface from "../../../Interfaces/TestFormInterface";
import StyledButton from "../../UI/StyledButton";
import { directus } from "../../../Api/FetchDirectus";
import { createItem } from "@directus/sdk";

const ApproveWindow = ({ data, close, openReg }: TestFormInterface) => {
  const navigate = useNavigate();

  function onClose() {
    close(false);
  }

  async function open() {
    window.scrollTo(0, 0);

    localStorage.setItem("courseInfo", JSON.stringify(data));

    let myCourses =
      JSON.parse(localStorage.getItem("my_courses") || "[]") || [];

    if (!myCourses.find((item: string) => item === data?.id)) {
      myCourses.push(data?.id);
    }

    localStorage.setItem("my_courses", JSON.stringify(myCourses));

    localStorage.setItem("active_course", JSON.stringify(data?.id));

    const age = localStorage.getItem("age");
    const gender = localStorage.getItem("gender");
    const activity = localStorage.getItem("activity");
    const position = localStorage.getItem("position");

    if (sessionStorage.getItem("token")) {
      try {
        await directus.request(
          createItem("Course_History", {
            email: localStorage.getItem("email"),
            url: "/modules",
            course: JSON.stringify(data),
            date: JSON.stringify(new Date()),
            scales: localStorage.getItem("scales"),
            completed: localStorage.getItem("completed"),
            certificat_completed: localStorage.getItem("certificat_completed"),
            certificat_link: localStorage.getItem("certificat_link"),
            my_courses: myCourses,
            active_course: data?.id,
            form: JSON.stringify({
              age: age,
              gender: gender,
              activity: activity,
              position: position,
            }),
          })
        );
        window.scrollTo(0, 0);
        navigate("/modules");
      } catch (error: any) {
        sessionStorage.removeItem("token");
        navigate("/");
      }
    } else {
      close(true);
      openReg(true);
    }
  }

  return (
    <div className="popUp">
      <div className="approvePopUp">
        <div className="closeFormBox">
          <div className="closeFormButton" onClick={onClose}>
            <span></span>
            <span></span>
          </div>
        </div>
        Вы уверены, что хотите сменить активный курс?
        <div className="approveButtonBox">
          <StyledButton text={"ДА"} onClick={open} />
          <StyledButton text={"НЕТ"} onClick={onClose} />
        </div>
      </div>
    </div>
  );
};

export default ApproveWindow;
